export const STEPS = {
  SLOTS: 'slots',
  USER_DATA: 'user-data-step',
  CONFIRMATION: 'confirmation',
} as const;
